export const ODENEK_EXPORT_COLUMNS = [
  {id: 'yil', label: 'Yıl'}, {id: 'isin_adi', label: 'İşin Adı'},
  {id: 'talep_yeri', label: 'Talep Yeri'}, {id: 'odenek_turu', label: 'Ödenek Türü'},
  {id: 'talep_tarihi', label: 'Talep Tarihi'}, {id: 'talep_yazisi_sayi_no', label: 'Talep Yazısı Sayı/No'},
  {id: 'talep_tutari', label: 'Talep Tutarı'}, {id: 'odenek_durumu', label: 'Ödenek Durumu'},
  {id: 'ihale_onayi', label: 'İhale Onayı'}, {id: 'ihale_onayi_talep_tarihi', label: 'İhale Onayı Talep Tarihi'},
  {id: 'ihale_onayi_talep_yazisi', label: 'İhale Onayı Talep Yazısı'},
  {id: 'ek_taahhut_talep_tarihi', label: 'Ek Taahhüt Tarihi'},
  {id: 'ek_protokol_talep_tarihi', label: 'Ek Protokol Tarihi'}
];

export const INITIAL_ODENEK_FORM_DATA = {
  yil: new Date().getFullYear(),
  isin_adi: '', talep_yeri: '', odenek_turu: '',
  talep_tarihi: '', talep_yazisi_sayi_no: '', talep_tutari: '',
  odenek_durumu: '', ihale_onayi: '',
  ihale_onayi_talep_tarihi: '', ihale_onayi_talep_yazisi: '',
  ek_taahhutler: [], ek_protokoller: [],
  ek_taahhut_talep_tarihi: '', ek_taahhut_talep_yazisi: '',
  ek_taahhut_talep_tutari: '', ek_taahhut_odenek_durumu: '',
  ek_protokol_talep_tarihi: '', ek_protokol_talep_yazisi: '',
  ek_protokol_talep_tutari: '', ek_protokol_odenek_durumu: ''
};

export const INITIAL_ODENEK_FILTERS = {
  isin_adi: '', yil: [], talep_yeri: [], odenek_turu: [], odenek_durumu: []
};
